import { MapCoord } from '../';

export class SearchResult {
	public address	= '';
	public coord		= new MapCoord();

	constructor(data: any, coord?: MapCoord) {
		if (typeof data === 'string') {
			this.address	= data;
			this.coord		= typeof coord === 'object' ? coord : this.coord;
		} else if (typeof data === 'object') {
			this.address	= typeof data.address	=== 'string'															? data.address									: this.address;
			this.coord		= typeof data.lat === 'number' && typeof data.lng === 'number'	? new MapCoord(data.lat, data.lng)	: this.coord;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/ui/searchResult.ts